{
  "close": "Schließen"
}
